import React, { useEffect } from "react";
import PhoneNumberInput from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import './PhoneInput.css';

interface PhoneInputProps {
    className?: string;
    placeholder?: string;
    value?: string;
    required?: boolean;
    title?: string;
    pattern?: string;
    onChange: (value?: string) => void;
}

export const PhoneInput = ({ className, placeholder, value, required, title, pattern, onChange }: PhoneInputProps) => {
    const [defaultCountry, setDefaultCountry] = React.useState();

    useEffect(() => {(async () => {
        const response = await fetch("https://ipinfo.io?token=71d21834e0ae72");
        const responseJson = await response.json();

        setDefaultCountry(responseJson?.country);
    })()}, []);

    return (
        <PhoneNumberInput
            defaultCountry={defaultCountry}
            className={className}
            international
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
            title={title}
            pattern={pattern}
        />
    );
}